import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type CrewingAnalyticsTab = 'executive-overview' | 'efficiency-breakdown' | 'hours-breakdown' | 'crewing-execution';

export interface CrewingAnalyticsTableConfigState {
  locationTable: string[];
  hoursCategoryTable: string[];
  qualityMetricsTable: string[];
  submissionDetailsTable: string[];
}

export interface CrewingAnalyticsUiState {
  activeTab: CrewingAnalyticsTab;
  selectedRegions: any[];
  selectedMarkets: any[];
  selectedLocations: any[];
  selectedYears: any[];
  selectedPeriods: any[];
  selectedWeeks: any[];
  selectedZones: any[];
  selectedCategories: any[];
  deliveryDateRange: { start: string | null; end: string | null };
  activeQuickSelect: 'wtd' | 'ptd' | 'qtd' | 'ytd' | 'lcw' | 'lcp' | null;
  chartHierarchyLevel: 'region' | 'market' | 'location';
  chartTimeframeGrain: 'year' | 'period' | 'week' | 'day';
  tableConfigs: CrewingAnalyticsTableConfigState;
}

// Timeframe dimensions (year/period/week) are unselected by default across all Crewing tables.
const defaultTableConfigs: CrewingAnalyticsTableConfigState = {
  locationTable: ['region', 'market', 'location', 'category', 'zone'],
  hoursCategoryTable: ['region', 'market', 'location', 'category', 'zone', 'size'],
  qualityMetricsTable: ['region', 'market', 'location', 'category', 'zone'],
  submissionDetailsTable: ['location', 'period', 'week'],
};

const initialState: CrewingAnalyticsUiState = {
  activeTab: 'executive-overview',
  selectedRegions: [],
  selectedMarkets: [],
  selectedLocations: [],
  // Defaults to the current year on first load — not "All years".
  selectedYears: [{ id: String(new Date().getFullYear()), displayText: String(new Date().getFullYear()) }],
  selectedPeriods: [],
  selectedWeeks: [],
  selectedZones: [],
  selectedCategories: [],
  deliveryDateRange: { start: null, end: null },
  activeQuickSelect: null,
  chartHierarchyLevel: 'region',
  chartTimeframeGrain: 'period',
  tableConfigs: defaultTableConfigs,
};

const crewingAnalyticsUiSlice = createSlice({
  name: 'crewingAnalyticsUi',
  initialState,
  reducers: {
    saveCrewingAnalyticsUiState: (state, action: PayloadAction<CrewingAnalyticsUiState>) => {
      return action.payload;
    },
    resetCrewingAnalyticsUiState: () => initialState,
  },
});

export const { saveCrewingAnalyticsUiState, resetCrewingAnalyticsUiState } = crewingAnalyticsUiSlice.actions;
export default crewingAnalyticsUiSlice.reducer;
